export default class Article{
    id;
    title;
    alias;
    description;
    ownerId;
    published;
    protected;
    favorite;
    categories;
    access_groups;
    read_by_contacts;
    security_groups;
    sections;
    tags;
    image_id;
    background_color;
    created;
    read_by;
    is_about_me;
    is_news_article;

    constructor(){    
        this.tags = [];
        this.categories = [];
        this.sections = [];
        this.access_groups = [];
        this.security_groups = [];
        this.ownerId = 0;

        this.created = new Date();
        this.alias = 'ny-artikel';
        this.feature_image = null;
        this.published = false;

        this.title = "";
        this.description = "";
        this.read_by_contacts = [];
        this.is_about_me = false;
        this.is_news_article = false;
    } 
}